import createScene from './experience/createScene.js'
import createSizes from './experience/createSizes.js'
import createCamera from './experience/createCamera.js'
import createRenderer from './experience/createRenderer.js'
import createLoaders from './experience/createLoaders.js'
import createEnvironment from './experience/createEnvironment.js'
import createLights from './experience/createLights.js'
import createWall from './experience/createWall.js'
import createDebug from './experience/createDebug.js'
import tick from './experience/tick.js'

import createSliceUniforms from './experience/createSliceUniforms.js'
import createSlicePatchMap from './experience/createSlicePatchMap.js'
import createSliceMaterials from './experience/createSliceMaterials.js'
import setupSliceGui from './experience/setupSliceGui.js'
import createSlicedModel from './experience/createSlicedModel.js'

import createWobbleMaterial from './experience/createWobbleMaterial.js'
import setupWobbleGui from './experience/setupWobbleGui.js'

/**
 * Base
 */
const canvas = document.querySelector('canvas.webgl')
const scene = createScene()
const sizes = createSizes()

/**
 * Debug
 */
const { gui } = createDebug()

/**
 * Camera + Renderer
 */
const { camera, update: updateCamera, resize: resizeCamera } = createCamera({ sizes, canvas })
scene.add(camera)

const { renderer, render, resize: resizeRenderer } = createRenderer({ canvas, sizes })

/**
 * Loaders + Environment
 */
const { rgbeLoader, gltfLoader } = createLoaders()

createEnvironment({
  scene,
  rgbeLoader,
  hdrUrl: './aerodynamics_workshop.hdr',
  blurriness: 0.5,
})

/**
 * Lights + Wall
 */
createLights({ scene })
createWall({ scene })

/**
 * Slice setup
 */
const uniforms = createSliceUniforms()
const patchMap = createSlicePatchMap()

const { makeSlicedFrom } = createSliceMaterials({ uniforms, patchMap })

setupSliceGui({ gui, uniforms })

/**
 * Wobble setup
 */
const dittoWobble = createWobbleMaterial({
  colorA: '#8dd5da',
  colorB: '#d990c3',
})

dittoWobble.uniforms.uStrength.value = 0.12

setupWobbleGui({ gui, wobble: dittoWobble, label: 'Ditto Wobble' })

/**
 * Model
 */
const modelState = createSlicedModel({
  scene,
  gltfLoader,
  url: './love-ball.glb',
  makeSlicedFrom,

  slicedMeshNames: ['Pokeball_1', 'Pokeball_2', 'Pokeball_3', 'Pokeball_4'],
  rotatingMeshNames: ['Pokeball_1', 'Pokeball_2', 'Pokeball_3', 'Pokeball_4'],

  wobble: dittoWobble,
  wobbleMeshNames: ['Ditto_1'],
})

/**
 * Resize
 */
sizes.onResize(() =>
{
  resizeCamera()
  resizeRenderer()
})

/**
 * Animate
 */
tick({
  update: (elapsedTime) =>
  {
    dittoWobble.uniforms.uTime.value = elapsedTime

    for (const mesh of modelState.rotatingMeshes)
    {
      mesh.rotation.z = - elapsedTime * 0.3
    }

    updateCamera()
    render(scene, camera)
  }
})
